import React from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Loading, ResourceCard, EmptyState } from "@/components/shared";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function Saved() {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["dashboard"], queryFn: async () => (await api.get("/dashboard")).data });
  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-bold tracking-tight text-navy">Saved resources</h1>
        <p className="mt-1 text-slate-600">Everything you've bookmarked for later.</p>
      </div>
      {isLoading ? <Loading /> : (data?.saved_resources?.length ? (
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{data.saved_resources.map((r) => <ResourceCard key={r.id} r={r} />)}</div>
      ) : <EmptyState title="No saved resources yet" subtitle="Browse the library and bookmark resources to find them here." action={<Button onClick={() => navigate("/resources")} className="mt-4 rounded-md bg-emerald text-white hover:bg-emerald-700" data-testid="saved-browse-btn">Browse library</Button>} />)}
    </DashboardLayout>
  );
}
